import NO05, { NO05SearchParams, NO05StatusStat } from '../../models/NO05';
import * as actionTypes from './actionTypesNO05';

export const NO05StatsRequest = (companyId: string) => ({
  type: actionTypes.NO05_STATS_REQUEST,
  payload: companyId,
});

export const NO05StatsSuccess = (stats: NO05StatusStat[]) => ({
  type: actionTypes.NO05_STATS_SUCCESS,
  payload: stats,
});

export const NO05StatsFailure = (error: string) => ({
  type: actionTypes.NO05_STATS_FAILURE,
  payload: error,
});

export const NO05SearchRequest = (searchParams: NO05SearchParams) => ({
  type: actionTypes.NO05_SEARCH_REQUEST,
  payload: searchParams,
});

export const NO05SearchSuccess = (orders: NO05[], hasMore: boolean) => ({
  type: actionTypes.NO05_SEARCH_SUCCESS,
  payload: { orders, hasMore },
});

export const NO05SearchFailure = (error: string) => ({
  type: actionTypes.NO05_SEARCH_FAILURE,
  payload: error,
});

export const NO05LoadMoreRequest = (searchParams: NO05SearchParams) => ({
  type: actionTypes.NO05_LOAD_MORE_REQUEST,
  payload: searchParams,
});

export const NO05LoadMoreSuccess = (orders: NO05[], hasMore: boolean) => ({
  type: actionTypes.NO05_LOAD_MORE_SUCCESS,
  payload: { orders, hasMore },
});

export const NO05LoadMoreFailure = (error: string) => ({
  type: actionTypes.NO05_LOAD_MORE_FAILURE,
  payload: error,
});

export const NO05SetStatus = (status: string) => ({
  type: actionTypes.NO05_SET_STATUS,
  payload: status,
});

export const NO05ClearResults = () => ({
  type: actionTypes.NO05_CLEAR_RESULTS,
});

export const NO05ResetForm = (isEnabled: boolean) => ({
  type: actionTypes.NO05_RESET_FORM,
  payload: isEnabled,
});

export const NO05ClearComponentStore = () => ({
  type: actionTypes.NO05_CLEAR_COMPONENT_STORE,
});

export const NO05OrderDetailRequest = (companyId: number, orderNumber: string) => ({
  type: actionTypes.NO05_ORDER_DETAIL_REQUEST,
  payload: { companyId, orderNumber },
});

export const NO05OrderDetailSuccess = (data: any) => ({
  type: actionTypes.NO05_ORDER_DETAIL_SUCCESS,
  payload: data,
});

export const NO05OrderDetailFailure = (error: string) => ({
  type: actionTypes.NO05_ORDER_DETAIL_FAILURE,
  payload: error,
});

export const NO05OrderDetailClear = () => ({
  type: actionTypes.NO05_ORDER_DETAIL_CLEAR,
});

export const NO05SelectAll = () => ({
  type: actionTypes.NO05_SELECT_ALL,
});

export const NO05SetSelected = (orderNrs: string[]) => ({
  type: actionTypes.NO05_SET_SELECTED,
  payload: orderNrs,
});
